import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountResource, Organization, OrganizationResource, SubscriptionPlan, SubscriptionPlanResource } from '@apaq/orgkit-js';
import { Roles } from 'src/app/common/security/roles';
import { timeout } from 'src/app/common/time/timeout';
import { container } from 'tsyringe';
import { DialogRef } from '../../dialog/dialog-ref';
import { DIALOG } from '../../dialog/dialog.service';
import { PageRequest } from '@apaq/leap-data-core';
import { ContextService } from 'ngx-orgkit';

@Component({
  selector: 'app-create-organization-dialog',
  templateUrl: './create-organization-dialog.component.html',
  styleUrls: ['./create-organization-dialog.component.scss']
})
export class CreateOrganizationDialogComponent implements OnInit {

  currencyMap = new Map<string, string>([
    ['DK', 'DKK'],
    ['FO', 'DKK'],
    ['NO', 'NOK']
  ]);

  languageMap = new Map<string, string>([
    ['DK', 'da'],
    ['FO', 'fo'],
    ['NO', 'nb']
  ]);

  form: FormGroup;
  saving = false;
  subscriptionPlan?: SubscriptionPlan;

  constructor(fb: FormBuilder, @Inject(DIALOG) private dialog: DialogRef, private contextService: ContextService,
    private organizationResource: OrganizationResource,
    private accountResource: AccountResource,
    private subscriptionPlanResource?: SubscriptionPlanResource) {
    this.form = fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      countryCode: ['DK', [Validators.required]],
      registrationNo: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]]
    })

    this.form.get('countryCode')?.valueChanges.subscribe(_ => this.loadSubscriptionPlan());
  }

  ngOnInit(): void {
    this.loadSubscriptionPlan();
  }

  async loadSubscriptionPlan() {
    const countryCode = this.form.get('countryCode')?.value;
    const plans = (await this.subscriptionPlanResource?.findAll({query: {countryCode}} as PageRequest))?.content;
    this.subscriptionPlan = plans?.find(p => p.type === 'Core');
  }

  async save() {
    this.saving = true;
    try {
      const org = this.form.value as Organization;
      org.location = [0,0];
      org.baseCurrency = this.currencyMap.get(org.countryCode) ?? 'DKK';
      org.email = this.contextService.account.email;
      org.languageCode = this.languageMap.get(org.languageCode) ?? 'da';
      org.subscriptionPlan = this.subscriptionPlan?.id!;
      const result = await this.organizationResource.save(org);
      let accountReady = false;

      for(let i=0;i<10;i++) {
        await timeout(500);
        const account = await this.accountResource.findById('current');
        if(account.roles.find(r => Roles.getOrganizationId(r) === result.id) != null) {
          accountReady = true;
          break;
        }
      }

      if(!accountReady) {
        Stallion.alert($localize`An error occured while creating the new organization. Please reload your browser.`)
      }
      this.dialog.close(true);
    } finally {
      this.saving = false;
    }
  }

  cancel() {
    this.dialog.close(false);
  }
}
